/* Manomaze i18n — minimal IT/EN toggle
   Reads saved pref from localStorage, falls back to navigator, default EN.
   Applies translations to:
     [data-i18n-en] + [data-i18n-it]           → textContent
     [data-i18n-en-html] + [data-i18n-it-html] → innerHTML
   Emits 'mzlangchange' CustomEvent on document when lang changes.
   Exposes window.MZ_LANG.get() / .set(lang).
*/
(function () {
  var STORAGE_KEY = 'mz_lang';
  var DEFAULT = 'en';

  function detect() {
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved === 'it' || saved === 'en') return saved;
    } catch (e) {}
    var nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
    if (nav.indexOf('it') === 0) return 'it';
    return DEFAULT;
  }

  var current = detect();

  function apply(lang) {
    if (lang !== 'it' && lang !== 'en') return;
    current = lang;
    try { localStorage.setItem(STORAGE_KEY, lang); } catch (e) {}
    document.documentElement.setAttribute('lang', lang);
    document.documentElement.setAttribute('data-lang', lang);

    var textEls = document.querySelectorAll('[data-i18n-en][data-i18n-it]');
    for (var i = 0; i < textEls.length; i++) {
      var el = textEls[i];
      var val = el.getAttribute('data-i18n-' + lang);
      if (val !== null) el.textContent = val;
    }

    var htmlEls = document.querySelectorAll('[data-i18n-en-html][data-i18n-it-html]');
    for (var j = 0; j < htmlEls.length; j++) {
      var hel = htmlEls[j];
      var hval = hel.getAttribute('data-i18n-' + lang + '-html');
      if (hval !== null) hel.innerHTML = hval;
    }

    var ev;
    try {
      ev = new CustomEvent('mzlangchange', { detail: { lang: lang } });
    } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent('mzlangchange', false, false, { lang: lang });
    }
    document.dispatchEvent(ev);

    var opts = document.querySelectorAll('.mz-lang__opt');
    for (var s = 0; s < opts.length; s++) {
      if (opts[s].getAttribute('data-lang') === lang) {
        opts[s].classList.add('is-active');
      } else {
        opts[s].classList.remove('is-active');
      }
    }
  }

  function init() {
    apply(current);
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.mz-lang__opt');
      if (!t) return;
      e.preventDefault();
      apply(t.getAttribute('data-lang'));
    });
  }

  window.MZ_LANG = {
    get: function () { return current; },
    set: apply
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
